module.exports = __webpack_public_path__ + "static/media/dollarSign.9e4f2e13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dollarSign.svg
// module id = 364
// module chunks = 0